import { useEffect, useRef, useState } from "react";
import WallReportModalContent, { WallImageSet } from "./WallModalModalContent";
import useModalActions from "@hooks/common/useModalAction";
import BaseModalContent from "../BaseReportModalContent/BaseReportModalContetnt";
import { REPORT_MODAL_NAMES } from "config/labels";
import { useReportModal } from "@hooks/useReportModal";
import { captureSixDirections } from "@features/view/Surface3DUtilities";
import { usePanelContainer } from "@features/analysis/rendering/Panels/usePanelContainer";
import { SurfaceContext, useBufferPool } from "@features/analysis/rendering/Panels/Renderers/vtkManagers";
import { useBrowserPage } from "@features/browser/useBrowserPage";


const WallReportModal = ({
  onClose,
}:{
  onClose: ()=>void,
}) => {
  const names = REPORT_MODAL_NAMES.lawall;
  const [imageMap, setImageMap] = useState<WallImageSet>({});
  const valueRef = useRef(0);

  const { waitingAction, closeLoadingModal } = useModalActions();
  const { analysisType } = usePanelContainer();
  const { contextPool } = useBufferPool();
  const { selectedSeriesId } = useBrowserPage();

  const poolRef = useRef(contextPool);
  useEffect(() => {
    poolRef.current = contextPool;
  }, [contextPool]);

  // const setter = async (args: any, wallThicknessValue: number)=>{
  //   (args as [string,Promise<any>][]).forEach(async (value)=>{
  //     const img =  await value[1];
  //     setImageMap( (prev)=>({
  //       ...prev,
  //       [value[0]] :img
  //     }))
  //   })
  //   valueRef.current = wallThicknessValue;
  // }


  // useEffect(() => {
  //   waitingAction({ message: 'Waiting' });
  // }, []);

  // useEffect(()=>{
  //   if(isDone){
  //     closeLoadingModal();
  //   }else if(!Object.keys(imageMap).length){
  //     console.log('모여?')
  //     scheduleRender('Surface3D', { type: 'captureSixDirections',setter});
  //   }
  // },[isDone])

  // if(!isDone)return;


  async function capture3d(
  ): Promise<string[] | undefined> {
    const d3context = {
      current: (poolRef.current['Surface3D'] as SurfaceContext),
    }
    if (!d3context) return;
    if (!d3context.current || !selectedSeriesId) return;
    waitingAction({ message: 'Waiting' });

    const results = await captureSixDirections(d3context, analysisType, selectedSeriesId!);
    if (results) {
      const map: WallImageSet = {
        one: results[1],
        two: results[2],
        three: results[3],
        four: results[4],
        five: results[5],
        six: results[0],
      };
      setImageMap(map);
    }

    const val = d3context.current.valueLAWT;

    console.log(val)
    if(val)
      valueRef.current = val;
    closeLoadingModal();
  }

  useEffect(() => {
    capture3d();
  }, []);


  return (
    <BaseModalContent
      title={names.title}
      vw={70}
      vh={70}
      onClose={onClose}
    >
      <WallReportModalContent imageSrc={{lawall:imageMap}} wallThicknessValue ={valueRef.current} />
    </BaseModalContent>
  )

}
export function useWallReportModal(res:{updateActivatedTool: (tool: any,check: boolean) => void}){
  return useReportModal({Component:WallReportModal,...res});
}
